<template>
  <AGTag class="ag-tag-etapa-analise" readonly :class="computedClass" :label="computedLabel" />
</template>

<script>
import AGTag from '@/components/common/AGTag.vue';
import ETAPA_ANALISE from '@/constants/ConstantEtapaAnalise';

export default {
  components: {
    AGTag,
  },

  props: {
    etapa: {
      type: String || Object,
      validatior: (val) => Object.values(ETAPA_ANALISE).includes(val),
    },
  },

  computed: {
    computedLabel() {
      if (!this.etapa) return 'Analisar';
      switch (this.etapa) {
        case ETAPA_ANALISE.ANALISAR:
          return 'Analisar';
        case ETAPA_ANALISE.PENDENTE_DE_ESCLARECIMENTO:
          return 'Esclarecimento';
        case ETAPA_ANALISE.EM_ANALISE:
          return 'Em análise';
        case ETAPA_ANALISE.APTO_PARA_REVISAO:
          return 'Apto para revisão';
        case ETAPA_ANALISE.REVISADO:
          return 'Revisado';
        case ETAPA_ANALISE.ANALISADO:
          return 'Analisado';
        default:
          console.error(`Etapa de análise "${this.etapa}" não está mapeado`);
          return this.etapa;
      }
    },

    computedClass() {
      const computedClass = [];
      if (!this.etapa) {
        computedClass.push('--etapa-analisar');
        return computedClass.join(' ');
      }
      switch (this.etapa) {
        case ETAPA_ANALISE.ANALISAR:
          computedClass.push('--etapa-analisar');
          break;
        case ETAPA_ANALISE.PENDENTE_DE_ESCLARECIMENTO:
          computedClass.push('--etapa-pendente-de-esclarecimento');
          break;
        case ETAPA_ANALISE.EM_ANALISE:
          computedClass.push('--etapa-em-analise');
          break;
        case ETAPA_ANALISE.APTO_PARA_REVISAO:
          computedClass.push('--etapa-apto-para-revisao');
          break;
        case ETAPA_ANALISE.REVISADO:
          computedClass.push('--etapa-revisado');
          break;
        case ETAPA_ANALISE.ANALISADO:
          computedClass.push('--etapa-analisado');
          break;
        default:
          console.error(`Etapa de análise "${this.etapa}" não está mapeado`);
          break;
      }

      return computedClass.join(' ');
    },
  },
};
</script>

<style lang="scss" scoped>
@mixin tagTypeStyles($backgroundColor, $textColor, $borderColor) {
  background-color: $backgroundColor !important;
  color: $textColor;
  border-color: $borderColor;
}

.ag-tag-etapa-analise {
  border: none;

  &.--etapa-analisar {
    @include tagTypeStyles(#8e8e93, #000000, #8e8e93);
  }

  &.--etapa-pendente-de-esclarecimento {
    @include tagTypeStyles(#fae1fa, #610051, #fae1fa);
  }

  &.--etapa-em-analise {
    @include tagTypeStyles(#8e8e9347, #8e8e93, #8e8e9347);
  }

  &.--etapa-apto-para-revisao {
    @include tagTypeStyles(#c7c7cc, #000000, #c7c7cc);
  }

  &.--etapa-revisado {
    @include tagTypeStyles(#d1d1d6, #000000, #d1d1d6);
  }

  &.--etapa-analisado {
    @include tagTypeStyles(#d5d1e9, #442d96, #d5d1e9);
  }
}
</style>
